import {InputHTMLAttributes} from 'react'

interface Props {
	id: string
	label: string
	onChange: (evt: any) => void
	type?: string
	value: any
	inputProps?: InputHTMLAttributes<any>
}

export default function FormInput(props: Props) {
	return (
		<div className="mb-4 flex justify-between items-center">
			<label
				className="text-gray-700 text-sm font-bold m-0 text-start"
				htmlFor={props.id}
			>{props.label}</label>
			<input
				className="shadow appearance-none border rounded w-3/4 py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
				id={props.id}
				onChange={props.onChange}
				placeholder={props.label}
				type={props.type ?? 'text'}
				value={props.value}
				{...props.inputProps}
			/>
		</div>
	)
}
